import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";

export function CreateIconOrder(params?: any) {
  if (params.nameColumn.ordinationValue === 'asc') return <FaSortUp color="#FFC007" size={11} />;
  else if (params.nameColumn.ordinationValue === 'desc') return <FaSortDown color="#FFC007" size={11} />;
  else return <FaSort size={11} />;
}